import { env } from '@/lib/env/env.mjs';

export type FeatureGateKey =
  | 'adminUserLifecycleActions'
  | 'adminUserMfaReset'
  | 'formRequiredMarkers'
  | 'formReservedErrorSpace';

export type FeatureGateDefinition = {
  defaultEnabled: boolean;
  envVar: string;
  isEnabled: () => boolean;
  label: string;
};

export const featureGateDefinitions: Record<FeatureGateKey, FeatureGateDefinition> = {
  adminUserLifecycleActions: {
    defaultEnabled: false,
    envVar: 'NEXT_PUBLIC_FEATURE_ADMIN_USER_LIFECYCLE_ACTIONS',
    isEnabled: () => env.NEXT_PUBLIC_FEATURE_ADMIN_USER_LIFECYCLE_ACTIONS === true,
    label: 'Admin user lifecycle actions',
  },
  adminUserMfaReset: {
    defaultEnabled: false,
    envVar: 'NEXT_PUBLIC_FEATURE_ADMIN_USER_MFA_RESET',
    isEnabled: () => env.NEXT_PUBLIC_FEATURE_ADMIN_USER_MFA_RESET === true,
    label: 'Admin user MFA reset',
  },
  formRequiredMarkers: {
    defaultEnabled: true,
    envVar: 'NEXT_PUBLIC_FEATURE_FORM_REQUIRED_MARKERS',
    isEnabled: () => env.NEXT_PUBLIC_FEATURE_FORM_REQUIRED_MARKERS !== false,
    label: 'Form required field markers',
  },
  formReservedErrorSpace: {
    defaultEnabled: false,
    envVar: 'NEXT_PUBLIC_FEATURE_FORM_RESERVED_ERROR_SPACE',
    isEnabled: () => env.NEXT_PUBLIC_FEATURE_FORM_RESERVED_ERROR_SPACE === true,
    label: 'Form reserved error message space',
  },
};

export function isFeatureGateEnabled(featureGate: FeatureGateKey): boolean {
  return featureGateDefinitions[featureGate].isEnabled();
}

export function getFeatureGateDefinition(featureGate: FeatureGateKey): FeatureGateDefinition {
  return featureGateDefinitions[featureGate];
}
